@if (state) {
    <mat-icon class="icon-1x" aria-label="Status" matTooltip="{{ state | titlecase }}"
        [ngClass]="'status ' + state"
    >
        {{ icon }}
    </mat-icon>
}